import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'fr');
}

i18n
  .use(Backend)
  .use(LanguageDetector, {
    order: ['cookie', 'localStorage', 'navigator'],
  })
  .use(initReactI18next)

  .init({
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;